import React from "react";

const Footer = () => {
  return <footer>© {new Date().getFullYear()} School Inventory System</footer>;
};

export default Footer;
